module.exports = __webpack_public_path__ + "06_mustache_black.3cfd377a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer3/06_mustache_black.png
// module id = HXsY
// module chunks = 0